import Layout from "./layout";
import Widgets from "./widgets";
import {widgetContainer, WidgetContainer} from "./widget-container/WidgetContainerComponent";

export default function() {
    return angular.module("tfApp.dashboard.oms.components", [Layout(), Widgets()])
                  .component(WidgetContainer, widgetContainer())
                  .name;
}
